import React from 'react';
import './RecomendationSection.css';
import SelectedSevenGoal from './TemplateGoals/SelectedSevenGoal';
import './OolaSevenSection.css';
import './SelectSevenSection.css';

const INSTRUCTION_COPY =
    'Choose any 7 goals from the 21 available goals. They can come from any combination of the 7 areas.';

function getHelperText(totalSelected) {
    const remaining = 7 - totalSelected;
    if (remaining >= 7) return 'Choose 7 goals to continue.';
    if (remaining === 0) return 'Your 7 goals are ready.';
    if (remaining === 1) return 'Choose 1 more goal to continue.';
    return `Choose ${remaining} more goals to continue.`;
}

const SelectSevenSection = (props) => {
    const activeCategoryIndex = props.activeCategoryIndex ?? 0;
    const setActiveCategoryIndex =
        props.setActiveCategoryIndex ?? (() => {});

    const totalSelected = props.AllState.SelectedGoalsSeven.length;
    const canContinue = totalSelected === 7;
    const helperText = getHelperText(totalSelected);
    const activeGroup = props.AllState.SelectedGoalsGroup?.[activeCategoryIndex];
    const activeName = activeGroup?.Fs?.name ?? '';
    const activeColor = activeGroup?.Fs?.color ?? 'inherit';

    const prevIndex = activeCategoryIndex > 0 ? activeCategoryIndex - 1 : null;
    const nextIndex =
        activeCategoryIndex < 6 ? activeCategoryIndex + 1 : null;
    const prevGroup =
        prevIndex != null
            ? props.AllState.SelectedGoalsGroup?.[prevIndex]
            : null;
    const nextGroup =
        nextIndex != null
            ? props.AllState.SelectedGoalsGroup?.[nextIndex]
            : null;

    function selectGoal(indexF, area, selected, idL) {
        let curSel = selected;
        try {
            curSel = props.AllState.SelectedGoalsGroup[area].selected.find(
                (x) => x.id === idL
            ).selected;
        } catch (e) {
            curSel = false;
        }
        if (props.AllState.SelectedGoalsSeven.length > 6 && !curSel) {
            props.setShowSevenConfirm(true);
            return;
        }

        if (!curSel) {
            props.AllState.SelectedGoalsGroup[area].selected[
                indexF
            ].idL = `${area}${indexF}`;
            props.AllState.SelectedGoalsSeven.push(
                props.AllState.SelectedGoalsGroup[area].selected[indexF]
            );
            props.AllState.SelectedGoalsGroup[area].selected[
                indexF
            ].selected = true;
            props.AllState.SelectedGoalsGroup[area].selected[
                indexF
            ].id = `${area}${indexF}`;
            props.AllState.changeData(props.AllState);
            props.forceUpdate();
        } else {
            const selIndex = props.AllState.SelectedGoalsSeven.findIndex(
                (x) => x.idL === idL
            );
            props.AllState.SelectedGoalsSeven.find(
                (x) => x.id === idL
            ).selected = false;
            props.AllState.SelectedGoalsSeven.splice(selIndex, 1);
            props.AllState.changeData(props.AllState);
            props.forceUpdate();
        }
    }

    const headerCount = (
        <div className="pick7-header__count" aria-live="polite">
            {totalSelected} OF 7 SELECTED
        </div>
    );

    const headerBlock = (
        <div className="pick7-header">
            <div className="pick7-header__row">
                <div className="RecomendationTitleTop7">PICK 7 GOALS:</div>
                {headerCount}
            </div>
            <div className="pick7-header__row pick7-header__row--desc">
                <div className="RecomendationDescTop7 pick7-header__desc">
                    {INSTRUCTION_COPY}
                </div>
                <div className="pick7-header__helper">{helperText}</div>
            </div>
        </div>
    );

    const areaNav = (
        <div className="pick7-area-nav">
            {prevIndex != null ? (
                <button
                    type="button"
                    className="pick7-area-nav__btn pick7-area-nav__btn--prev"
                    style={{ color: prevGroup?.Fs?.color }}
                    onClick={() => setActiveCategoryIndex(prevIndex)}
                >
                    {'< PREVIOUS AREA: '}
                    {String(prevGroup?.Fs?.name ?? '').toUpperCase()}
                </button>
            ) : (
                <span className="pick7-area-nav__spacer" aria-hidden="true" />
            )}
            {nextIndex != null ? (
                <button
                    type="button"
                    className="pick7-area-nav__btn pick7-area-nav__btn--next"
                    style={{ color: nextGroup?.Fs?.color }}
                    onClick={() => setActiveCategoryIndex(nextIndex)}
                >
                    {'NEXT AREA: '}
                    {String(nextGroup?.Fs?.name ?? '').toUpperCase()}
                    {' >'}
                </button>
            ) : null}
        </div>
    );

    const stickyFooter = (
        <div className="pick7-sticky-footer">
            <div className="pick7-sticky-footer__status">
                {props.continueError ? (
                    <span className="pick7-sticky-footer__helper pick7-sticky-footer__helper--error">
                        {props.continueError}
                    </span>
                ) : (
                    <span className="pick7-sticky-footer__helper">
                        {helperText}
                    </span>
                )}
            </div>
            <button
                type="button"
                className={`pick7-sticky-footer__continue${
                    canContinue ? ' is-enabled' : ''
                }`}
                disabled={!canContinue}
                onClick={() => {
                    if (canContinue && props.confirmGoals) {
                        props.confirmGoals();
                    }
                }}
            >
                CONTINUE {'>'}
            </button>
        </div>
    );

    return (
        <div className="SelectSevenSection__container">
            <div className="hiddenMobile">{headerBlock}</div>

            <div className="recommendation__titles visibleMobile">
                <div className="titles__texts pick7-header">
                    <div className="pick7-header__row">
                        <h3 className="RecomendationTitleTop7">PICK 7 GOALS:</h3>
                        {headerCount}
                    </div>
                    <div className="pick7-header__row pick7-header__row--desc">
                        <p className="RecomendationDescTop7 pick7-header__desc">
                            {INSTRUCTION_COPY}
                        </p>
                        <p className="pick7-header__helper">{helperText}</p>
                    </div>
                </div>
            </div>

            <div className="selectGoalTop7__container pick7Goal__container">
                {activeGroup ? (
                    <div
                        className="pick7-category-panel"
                        key={`pick7-panel-${activeCategoryIndex}`}
                    >
                        <div
                            className="titleGroup pick7-category-panel__heading"
                            style={{ color: activeColor }}
                        >
                            {String(activeName).toUpperCase()}
                            {' GOALS'}
                        </div>

                        {activeGroup.selected.map((itemF, indexF) => (
                            <SelectedSevenGoal
                                selectGoal={selectGoal}
                                AllState={props.AllState}
                                itemF={itemF}
                                number={activeCategoryIndex}
                                indexF={indexF}
                                hideNav={false}
                                key={`SelectSevenSectionR${
                                    itemF.Id == null ? itemF.GoalId : itemF.Id
                                }`}
                            />
                        ))}
                    </div>
                ) : null}
            </div>

            {areaNav}
            {stickyFooter}
        </div>
    );
};

export default SelectSevenSection;
